/* eslint-disable no-new */
import KeenSlider from "keen-slider";

/**
 * Renders the upsell price in the sidecart. Upsells never show a discounted/strikethrough price.
 */
function renderUpsellProductPrice(product, container, widget) {
  const variant = product.selected_variant || product.variants?.[0];
  if (!variant) return;

  const formatMoney =
    (typeof widget.formatMoney === "function" &&
      widget.formatMoney.bind(widget)) ||
    window.Rebuy?.util?.formatMoney ||
    window.Rebuy?.Cart?.formatMoney;

  if (!formatMoney) return;

  container.classList.add(
    "product-price",
    "rebuy-product-price",
    "tw-text-3",
    "tw-font-semibold",
    "tw-leading-3",
    "tw-flex",
    "tw-gap-x-1.5"
  );

  // Sidecart upsells always show the regular variant price: no global discount and no strikethrough/compare-at.
  const price = document.createElement("span");
  price.classList.add("rebuy-money");
  // Use the raw Shopify variant price; widget.variantPrice() applies Rebuy widget discounts.
  const regularPrice =
    variant.price != null
      ? variant.price
      : widget?.variantPrice?.(product, variant);
  price.innerHTML = formatMoney(regularPrice);
  container.appendChild(price);
}

export const rebuyUpsellSmartCartSlider = () => {
  document.addEventListener("rebuy.ready", (event) => {
    const RebuySmartCartCrossSells =
      window.Rebuy?.SmartCart?.settings?.cross_sells;

    if (!RebuySmartCartCrossSells) return;

    if (
      event.detail.widget?.id &&
      RebuySmartCartCrossSells.includes(event.detail.widget.id)
    ) {
      const widget = event.detail.widget;
      const rebuyContainerEl = document.querySelector(".rebuy-upsell");
      // Container styling
      rebuyContainerEl.classList.add(
        "tw-py-4",
        "tw-pl-5",
        "tw-w-full",
        "rebuy-upsell-item-container",
        "tw-border-solid"
      );
      rebuyContainerEl.setAttribute("role", "region");
      rebuyContainerEl.setAttribute("aria-label", "Product recommendations");

      // Arrow Container
      const titleContainerEl = document.createElement("div");
      titleContainerEl.classList.add(
        "tw-flex",
        "tw-justify-between",
        "tw-items-center",
        "tw-pb-3",
        "tw-pr-5"
      );
      rebuyContainerEl.appendChild(titleContainerEl);

      // Widget Title
      const widgetTitle = event.detail.widget.data.config.language.title;
      const newWidgetTitle = document.createElement("div");
      const widgetTitleContent = document.createTextNode(widgetTitle);
      newWidgetTitle.appendChild(widgetTitleContent);
      newWidgetTitle.classList.add(
        "tw-text-[16px]",
        "md:tw-text-[20px]",
        "tw-font-extrabold",
        "tw-leading-[14px]",
        "tw-pr-2",
        "tw-flex-1"
      );
      titleContainerEl.appendChild(newWidgetTitle);

      // Arrow Container
      const arrowContainerEl = document.createElement("div");
      arrowContainerEl.classList.add("tw-flex", "tw-items-center");
      titleContainerEl.appendChild(arrowContainerEl);

      // Arrow Right SVG
      const arrowRightEl = document.createElement("button");
      arrowRightEl.classList.add(
        "tw-flex",
        "tw-bg-transparent",
        "tw-w-[24px]",
        "tw-h-[24px]",
        "tw-p-0",
        "tw-border-none"
      );
      arrowRightEl.id = "arrow-right";
      arrowRightEl.ariaLabel = "Slider previous button";
      arrowRightEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g>
    <path d="M21.0001 11.9999C21.0001 12.1988 20.9211 12.3896 20.7804 12.5303C20.6398 12.6709 20.449 12.7499 20.2501 12.7499H5.56041L11.0307 18.2193C11.1004 18.289 11.1557 18.3717 11.1934 18.4628C11.2311 18.5538 11.2505 18.6514 11.2505 18.7499C11.2505 18.8485 11.2311 18.9461 11.1934 19.0371C11.1557 19.1281 11.1004 19.2109 11.0307 19.2806C10.961 19.3502 10.8783 19.4055 10.7873 19.4432C10.6962 19.4809 10.5986 19.5003 10.5001 19.5003C10.4016 19.5003 10.304 19.4809 10.2129 19.4432C10.1219 19.4055 10.0392 19.3502 9.96948 19.2806L3.21948 12.5306C3.14974 12.4609 3.09443 12.3782 3.05668 12.2871C3.01894 12.1961 2.99951 12.0985 2.99951 11.9999C2.99951 11.9014 3.01894 11.8038 3.05668 11.7127C3.09443 11.6217 3.14974 11.539 3.21948 11.4693L9.96948 4.7193C10.1102 4.57857 10.3011 4.49951 10.5001 4.49951C10.6991 4.49951 10.89 4.57857 11.0307 4.7193C11.1715 4.86003 11.2505 5.05091 11.2505 5.24993C11.2505 5.44895 11.1715 5.63982 11.0307 5.78055L5.56041 11.2499H20.2501C20.449 11.2499 20.6398 11.3289 20.7804 11.4696C20.9211 11.6103 21.0001 11.801 21.0001 11.9999Z" fill="#034638"/>
  </g>
</svg>
      `;
      arrowContainerEl.appendChild(arrowRightEl);
      const arrowRight = rebuyContainerEl.querySelector("#arrow-right");

      // Arrow Left SVG
      const arrowLeftEl = document.createElement("button");
      arrowLeftEl.classList.add(
        "tw-flex",
        "tw-bg-transparent",
        "tw-w-[24px]",
        "tw-h-[24px]",
        "tw-p-0",
        "tw-border-none",
        "tw-ml-2"
      );
      arrowLeftEl.id = "arrow-left";
      arrowLeftEl.ariaLabel = "Slider next button";
      arrowLeftEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M20.7806 12.5306L14.0306 19.2806C13.8899 19.4213 13.699 19.5003 13.5 19.5003C13.301 19.5003 13.1101 19.4213 12.9694 19.2806C12.8286 19.1398 12.7496 18.949 12.7496 18.7499C12.7496 18.5509 12.8286 18.36 12.9694 18.2193L18.4397 12.7499H3.75C3.55109 12.7499 3.36032 12.6709 3.21967 12.5303C3.07902 12.3896 3 12.1988 3 11.9999C3 11.801 3.07902 11.6103 3.21967 11.4696C3.36032 11.3289 3.55109 11.2499 3.75 11.2499H18.4397L12.9694 5.78055C12.8286 5.63982 12.7496 5.44895 12.7496 5.24993C12.7496 5.05091 12.8286 4.86003 12.9694 4.7193C13.1101 4.57857 13.301 4.49951 13.5 4.49951C13.699 4.49951 13.8899 4.57857 14.0306 4.7193L20.7806 11.4693C20.8504 11.539 20.9057 11.6217 20.9434 11.7127C20.9812 11.8038 21.0006 11.9014 21.0006 11.9999C21.0006 12.0985 20.9812 12.1961 20.9434 12.2871C20.9057 12.3782 20.8504 12.4609 20.7806 12.5306Z" fill="#034638"/>
</svg>`;
      arrowContainerEl.appendChild(arrowLeftEl);
      const arrowLeft = rebuyContainerEl.querySelector("#arrow-left");

      // Products Wrapper
      const productsWrapper = document.createElement("div");
      productsWrapper.classList.add("keen-slider");
      rebuyContainerEl.appendChild(productsWrapper);

      const renderProducts = (productsArray) => {
        // Clear previous products
        productsWrapper.innerHTML = "";

        productsArray.forEach((product) => {
          // Product Container
          const productContainer = document.createElement("div");
          productContainer.classList.add(
            "tw-rounded-[10px]",
            "tw-border",
            "tw-border-solid",
            "tw-border-hunter-green/25",
            "tw-bg-white",
            "tw-flex",
            "tw-items-center",
            "keen-slider__slide"
          );
          productsWrapper.appendChild(productContainer);

          // Product Image
          const productImageEl = document.createElement("img");
          productImageEl.src = product.image.src;
          productImageEl.alt = product.title;
          productImageEl.classList.add(
            "product-image",
            "tw-w-[26px]",
            "tw-h-12",
            "tw-mr-2",
            "tw-object-contain"
          );
          productContainer.appendChild(productImageEl);

          // Product Title & price wrapper
          const productInfoWrapperEl = document.createElement("div");
          productInfoWrapperEl.classList.add(
            "product-info-wrapper",
            "tw-flex",
            "tw-flex-col",
            "tw-justify-center",
            "tw-flex-1"
          );
          productContainer.appendChild(productInfoWrapperEl);

          // Product Title
          const newProductsEl = document.createElement("div");
          const productTitle = document.createTextNode(product.title);
          newProductsEl.appendChild(productTitle);
          newProductsEl.classList.add(
            "product-title",
            "tw-text-3",
            "tw-font-semibold",
            "tw-leading-3",
            "tw-pb-2"
          );
          productInfoWrapperEl.appendChild(newProductsEl);
          // Product Price (same logic as cart line items via oliRebuyLine*)
          const productPriceContainer = document.createElement("div");
          renderUpsellProductPrice(product, productPriceContainer, widget);
          productInfoWrapperEl.appendChild(productPriceContainer);

          // Product Add button
          const addButtonEl = document.createElement("button");
          const addButtonLanguage = document.createTextNode(
            event.detail.widget.data.config.language.add_to_cart
          );
          addButtonEl.ariaLabel = `Add ${product.title}`;
          addButtonEl.appendChild(addButtonLanguage);
          addButtonEl.classList.add(
            "tw-text-white",
            "tw-bg-hunter-green",
            "tw-rounded-[100px]",
            "tw-py-2",
            "tw-px-3",
            "tw-font-semibold",
            "tw-border-none",
            "tw-font-body",
            "tw-text-3",
            "tw-leading-3"
          );
          addButtonEl.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H10.625V16.875C10.625 17.0408 10.5592 17.1997 10.4419 17.3169C10.3247 17.4342 10.1658 17.5 10 17.5C9.83424 17.5 9.67527 17.4342 9.55806 17.3169C9.44085 17.1997 9.375 17.0408 9.375 16.875V10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375H9.375V3.125C9.375 2.95924 9.44085 2.80027 9.55806 2.68306C9.67527 2.56585 9.83424 2.5 10 2.5C10.1658 2.5 10.3247 2.56585 10.4419 2.68306C10.5592 2.80027 10.625 2.95924 10.625 3.125V9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10Z" fill="#034638"/>
        </svg>`;

          addButtonEl.onclick = function () {
            // Set the loading spinner as the button content
            addButtonEl.innerHTML = `<svg class="tw-animate-spin tw-h-5 tw-w-5 tw-text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
            </svg>`;

            widget.addToCart(product);

            productChangeEvent();
          };
          productContainer.appendChild(addButtonEl);
        });

        // Re-initiate Keen Slider
        new KeenSlider(productsWrapper, {
          loop: true,
          breakpoints: {
            "(min-width: 750px)": {
              slides: {
                perView: 1.5,
                spacing: 8,
              },
            },
          },
          slides: {
            perView: 1.2,
            spacing: 8,
          },
          created: function (slide) {
            arrowRight.addEventListener("click", function () {
              slide.prev();
            });

            arrowLeft.addEventListener("click", function () {
              slide.next();
            });
          },
        });
      };

      function productChangeEvent() {
        document.addEventListener("rebuy.productsChange", function (event) {
          renderProducts(event.detail.products);
        });
      }

      renderProducts(event.detail.widget.data.products);
      productChangeEvent();
    }
  });
};
